import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'src/store';
import { thunks } from 'src/thunks/process-module';
import { useApiRequest } from './use-api-request';

export const useProcessModules = () => {
  const processModules = useSelector((state) => state.processModule.processModules);
  const dispatch = useDispatch();

  // Use centralized API request management
  const { isLoading, isUnauthorized, hasFetched, refetch } = useApiRequest(
    async () => {
      await dispatch(thunks.getProcessModules());
      return processModules; // Return the process modules data
    },
    {
      requestKey: 'getProcessModules',
    },
  );

  return processModules.list || [];
};
